import { useState } from "react";
import dayjs from 'dayjs';
import { Button, Paper } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';

import { columns } from "./grid-columns";
import { ServiceGroupForm } from "./service-group.form";
import { groupFormSchema } from "./service-group-form.schema";
import { SiTrackPage } from "../../../components/si-track-page";
import { ServiceGroup } from "../../../models/masters/service-group";
import { SaveHookFormDialog } from "../../../components/save-hook-form.dialog";
import { SiTrackGrid } from "../../../components/si-track-grid/si-track-grid";
import { serviceGroupApiKeyStore } from "../../../api/masters/service-group-api-key-store";
import { GuardedComponent } from "../../../components/guarded-component";
import { UserPermissionName } from "../../../models/user-permission-name";

const styling = {
    paperStyle: { padding: '20px', borderRadius: '20px' },
};

export const ServiceGroupPage = () => {
    const [editItem, setEditItem] = useState<Partial<ServiceGroup>>();

    const handleEditGroup = (group: ServiceGroup) => {
        setEditItem(group);
    };
    const handleEditClose = () => {
        setEditItem(undefined);
    };
    const handleCreateGroup = () => {
        setEditItem({ isActive: true });
    };
    return (
        <SiTrackPage
            title="Service Groups"
            actionButton={
                <GuardedComponent requiredPermissions={[UserPermissionName.ADD_SERVICEGROUP]}>
                    <Button
                        size="small"
                        variant="contained"
                        disableElevation={true}
                        startIcon={<AddIcon />}
                        onClick={handleCreateGroup}
                    >
                        Add Service Group
                    </Button>
                </GuardedComponent>
            }
        >
            <Paper elevation={0} style={styling.paperStyle}>
                <SiTrackGrid
                    fileTitle='service_group'
                    dataItemKey="serviceGroupID"
                    columns={columns}
                    queryConfig={serviceGroupApiKeyStore.getServiceGroups()}
                    onEdit={handleEditGroup}
                    deleteMutationConfig={(deleteItem) => serviceGroupApiKeyStore.deleteServiceGroup(deleteItem.serviceGroupID)}
                    actionPermissions={{
                        edit: UserPermissionName.EDIT_SERVICEGROUP,
                        delete: UserPermissionName.DELETE_SERVICEGROUP,
                        export: UserPermissionName.DOWNLOAD_GRID
                    }}
                />
                {editItem && (
                    <SaveHookFormDialog
                        title={editItem.serviceGroupID ? 'UPDATE SERVICE GROUP' : 'CREATE SERVICE GROUP'}
                        config={{
                            saveConfig: editItem.serviceGroupID
                                ? serviceGroupApiKeyStore.updateServiceGroup()
                                : serviceGroupApiKeyStore.createServiceGroup(),
                            invalidateRoute: () => serviceGroupApiKeyStore.getServiceGroups(),
                        }}
                        data={editItem}
                        yupSchema={groupFormSchema}
                        onClose={handleEditClose}
                        size="xs"
                    >
                        <ServiceGroupForm />
                    </SaveHookFormDialog>
                )}
            </Paper>
        </SiTrackPage>
    );
}